export interface User {
    uid?: string;
    email?: string;
    password?: string;
    displayName?: string;
    role?: Roles;
    lastSignInTime?: string | null;
    creationTime?: string;
}

export enum Roles {
    OWNER = "owner",
    ADMIN = "admin",
    USER = "user",
}
